// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paid .ant-form {\n  display: flex;\n  align-items: center;\n}\n.paid .ant-table .ant-table-thead > tr > th {\n  text-align: center !important;\n}", ""]);
// Exports
module.exports = exports;
